import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const requireAuth = () => (from, to, next) => {
  if (store.getters.getAuth) return next() // isAuth === true면 페이지 이동
  next('/login') // isAuth === false면 다시 로그인 화면으로 이동
}

export default new Router({
  mode: 'history',
  routes: [
    // Record Admin
    {
      path: '/',
      component: () => import('@/components/Admin'),
      beforeEnter: requireAuth(),
      children: [
        {//홈
          path: '/home',
          name: 'Home',
          component: () => import('@/components/Home')
        },

        {//사용자
          path: '/users',
          name: 'Users',
          component: () => import('@/components/users/Users')
        },
        {//사용자 상세
          path: '/users/:user_seq',
          name: 'User',
          component: () => import('@/components/users/User')
        },
        {//기록 목록
          path: '/records',
          name: 'Records',
          component: () => import('@/components/record/Records')
        },

        {//공간 목록
          path: '/rooms',
          name: 'Rooms',
          component: () => import('@/components/room/Rooms')
        },

        {//공간
          path: '/rooms',
          name: 'Rooms',
          component: () => import('@/components/room/Rooms')
        },
        {//공간
          path: '/rooms/:room_seq',
          name: 'Room',
          component: () => import('@/components/room/Room')
        },

        {//공지사항
          path: '/notice',
          name: 'Notice',
          component: () => import('@/components/notice/Notice')
        },

        {//문의사항
          path: '/inquiry',
          name: 'Inquiry',
          component: () => import('@/components/inquiry/Inquiry')
        },
        {//FAQ
          path: '/faq',
          name: 'Faq',
          component: () => import('@/components/faq/Faq')
        },

        {//신고 - 사용자
          path: '/report/profile',
          name: 'ReportProfile',
          component: () => import('@/components/report/Profile')
        },


        {//신고 - 기록
          path: '/report/record',
          name: 'ReportRecord',
          component: () => import('@/components/report/Record')
        },

        {//약관관리
          path: '/terms',
          name: 'Terms',
          component: () => import('@/components/terms/Terms')
        },
        {//앱버전관리
          path: '/version',
          name: 'Version',
          component: () => import('@/components/version/Version')
        },
        {//코드 그룹  관리
          path: '/code',
          name: 'Code',
          component: () => import('@/components/code/Code')
        },

        {//푸시 관리
          path: '/push',
          name: 'Push',
          component: () => import('@/components/push/Push')
        },

      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login')
    },
    {
      path: '*',
      name: 'error404',
      component: { template: '<div>Access Denied..</div>' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js